<script>
  import { getConfig } from '@app/config';
  import { isEmptyOrUndefinedString } from '@app/utils/util';
  import { eventList, filterEvents, getCertainEventPage, getNextEventPage, getPreviousEventPage, pageCount, pageNumber } from '@store/event-store';
  import { selectedEventKeywords } from '@store/keyword-store';
  import { onMount } from 'svelte';
  import { locale, _ } from 'svelte-i18n';
  import { get } from 'svelte/store';
  import EventListItem from '../dummy/EventListItem.svelte';
  import PagePicker from '../dummy/PagePicker.svelte';
  import SearchField from '../dummy/SearchField.svelte';
  import DatePicker from './DatePicker.svelte';
  import EventAudienceList from './EventAudienceList.svelte';
  import EventKeywordList from './EventKeywordList.svelte'; 
  // Can be empty here but it's required
  export let routeParams;

  const { events } = getConfig().modules;
  let filters = {};
  let isLoading = false;
  onMount(async () => {
     if (events.defaultPlaceId) {
     Object.assign(filters, { area: events.defaultPlaceId });
    }
    document.title = `${!isEmptyOrUndefinedString(events.header.headline[$locale]) ? events.header.headline[$locale] : event.header.headline.fi} - ${getConfig().site.title}`;
    if ($eventList.data.length < 1) {
      isLoading = true;
      await filterEvents(filters);
      isLoading = false;
    }
    else console.log('Events found in store');
  });

  async function searchQueryOnSubmit(event) {
    const searchQuery = event.target.searchQuery.value;
    Object.assign(filters, { searchQuery });
    isLoading = true;
    await filterEvents(filters);
    isLoading = false;
  }

  function searchQueryOnBlur(event) {
    console.log('OnBlur', event)
  }

  async function handleStarDateChange(date) {
    if (date) {
      Object.assign(filters, { startDate: date });
      console.log('Filters', filters);
      isLoading = true;
      await filterEvents(filters);
      isLoading = false;
    }
  }

  async function handleKeywordChange(event) {
    const keyword = event.target.value;

    if (keyword && keyword.length > 0) {
      Object.assign(filters, { keyword: [keyword] });
    } else {
      Object.assign(filters, { keyword: null });
    }

    console.log('Filters', filters);
    isLoading = true;
    await filterEvents(filters);
    isLoading = false;
  }

  async function handleKeywordClick() {
    const keywords = get(selectedEventKeywords);
    if(keywords.length > 0) {
      Object.assign(filters, { keywords });
      console.log('Filters', filters);
      isLoading = true;
      await filterEvents(filters);
      isLoading = false;
    } else {
      delete filters.keywords;
      console.log('Filters', filters);
      isLoading = true;
      await filterEvents(filters);
      isLoading = false;
    }
  }

  async function handleAudienceChange(event) {
    const audience = event.target.value;

    if (audience && audience.length > 0) {
      Object.assign(filters, { audience: [audience] });
    } else {
      Object.assign(filters, { audience: null });
    }

    console.log('Filters', filters);
    isLoading = true;
    await filterEvents(filters);
    isLoading = false;
  }

  let advancedSearchHidden = true;

  function toggleAdvancedSearchHidden() {
    if (advancedSearchHidden) {
      advancedSearchHidden = false;
    } else {
      advancedSearchHidden = true;
    }
  }

</script>

<div class="event-list" lang="{$locale}">
  <header class="event-list__header event-list__header--events">
    <div class="event-list__header__headline">
      <h1>{events.header.headline[$locale]}</h1>
    </div>
    <!-- <div class="event-list__header__subheader">
      <h3>{events.header.subHeader[$locale]}</h3>
    </div> -->
  </header>

  <section class="event-list__content">
    <h2 class="event-list__headline">{events.main.headline[$locale]}</h2>

    <div class="event-list__content__filter-row">
      <SearchField
        onSubmit="{searchQueryOnSubmit}"
        onBlur="{searchQueryOnBlur}"
        placeholder="{events.main.searchHint[$locale]}"/>
    </div>

    <button class="event-list__content__mobile-filter-selector" on:click="{toggleAdvancedSearchHidden}">
      <span>{$_('common.advanced_search')}</span>
      <i class="event-list__content__mobile-filter-selector__icon icon-arrow-down"></i>
    </button>

    <div class="event-list__content__filters {advancedSearchHidden ? 'event-list__content__filters--hidden' : '' }">
      <div class="event-list__content__filter-row">
        <div class="event-list__content__filter-row__item">
          <i class="event-list__content__filter-row__item__icon fa fa-calendar"></i>
          <DatePicker fieldName="startDate" onChange={handleStarDateChange} />
        </div>
        <!-- <div class="event-list__content__filter-row__item">
          <i class="event-list__content__filter-row__item__icon fa fa-compass"></i>
          <AreaSelector onChange={handleAreaChange} moduleName="events"/>
        </div> -->
        <div class="event-list__content__filter-row__item">
          <i class="event-list__content__filter-row__item__icon fa fa-user-o"></i>
          <EventAudienceList onChange={handleAudienceChange} />
        </div>
      </div>
      <div class="event-list__content__filter-row__item">
        <EventKeywordList onClick="{handleKeywordClick}" onChange="{handleKeywordChange}" />
      </div>
    </div>

    <div class="event-list__content__list" aria-live="polite" id="content-main">

      {#if isLoading} 
      <div class="loader-container">
        <span class="loader" />

        {$_('common.loading')} ... 
      </div>
      {:else}
      {#each $eventList.data as event}
        <a href="/event/{event.id}">
          <EventListItem event="{event}" moduleName="events"/>
        </a>
      {/each}
      {/if}
      {#if $eventList.data.length === 0 && !isLoading}
       {$_('event_list.no_events')}
      {/if}
    </div>

    <PagePicker
      nextPage="{getNextEventPage}"
      prevPage="{getPreviousEventPage}"
      toPage="{getCertainEventPage}"
      pageCount="{$pageCount}"
      currentPage="{$pageNumber}"
      metaData="{$eventList.meta}" />

    <div class="to_top" aria-label="{$_('common.to_top')}">
      <a href="#top">{$_('common.to_top')}</a>
    </div>
  </section>

</div>

<style></style>
